import { resultMeta } from "./scanResults";

/**
 * Kết quả vừa quét, chữ lớn để nhân viên kho nhìn từ xa.
 * Sai khách hàng (BRD §5.4): hiện rõ khách của đơn và khách đang xuất ngay trên trang.
 */
const LastScanPanel = ({ result, pending, sessionCustomer }) => {
  if (!result) {
    return (
      <div className="warehouse-last warehouse-last--idle">
        <div className="warehouse-last__title">Sẵn sàng quét</div>
        <div className="warehouse-last__detail">Đưa máy quét vào mã vận đơn trên kiện hàng</div>
      </div>
    );
  }
  const meta = resultMeta(result.result);
  if (result.result === "WRONG_CUSTOMER") {
    const orderCustomer = [result.orderCustomerCode, result.orderCustomerName].filter(Boolean).join(" - ");
    return (
      <div className="warehouse-last warehouse-last--danger" role="alert">
        <div className="warehouse-last__title">SAI KHÁCH HÀNG</div>
        <div className="warehouse-last__detail">Mã vận đơn: <b>{result.code}</b></div>
        <div className="warehouse-last__detail">Khách hàng của đơn: <b>{orderCustomer || "-"}</b></div>
        <div className="warehouse-last__detail">Khách hàng đang xuất: <b>{sessionCustomer || result.sessionCustomerCode || "-"}</b></div>
        {pending > 0 && <div className="warehouse-last__pending">Đang xử lý thêm {pending} mã...</div>}
      </div>
    );
  }
  return (
    <div className={`warehouse-last warehouse-last--${meta.variant}`}>
      <div className="warehouse-last__code">{result.code}</div>
      <div className="warehouse-last__title">{meta.label}</div>
      <div className="warehouse-last__detail">
        {result.message}
        {result.orderCode && <> · Đơn {result.orderCode}</>}
        {result.orderCustomerCode && <> · KH {result.orderCustomerCode}</>}
      </div>
      {pending > 0 && <div className="warehouse-last__pending">Đang xử lý thêm {pending} mã...</div>}
    </div>
  );
};

export default LastScanPanel;
